import { z } from 'zod';
import { TableNestSettingModel } from './project-filter';

export const TableColumnsSettingModel = z.string().array();

export const TableNestSettingStorageModel = z
  .record(z.string().uuid(), TableNestSettingModel)
  .optional();

export const TableColumnsSettingStorageModel = z
  .record(z.string().uuid(), TableColumnsSettingModel)
  .optional();
